import React from 'react';

const SvgExclamationMark = props => (
  <svg width={18} height={18} {...props}>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Stylesheet" transform="translate(-1051.000000, -483.000000)">
            <g id="Group-7-Copy" transform="translate(1051.000000, 483.000000)">
                <circle id="Oval" fill="#E91F4A" cx="9" cy="9" r="9"></circle>
                <text id="!" font-family="OpenSans-Bold, Open Sans" font-size="12" font-weight="bold" fill="#FFFFFF">
                    <tspan x="7.28320312" y="13.5">!</tspan>
                </text>
            </g>
        </g>
    </g>
  </svg>
);

export default SvgExclamationMark;
